/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
import { _ as r } from "../../chunks/tslib.es6.js";
import { isSome as o } from "../../core/arrayUtils.js";
import { ClonableMixin as e } from "../../core/Clonable.js";
import { JSONSupport as t } from "../../core/JSONSupport.js";
import { property as s } from "../../core/accessorSupport/decorators/property.js";
import { cast as l } from "../../core/accessorSupport/decorators/cast.js";
import "../../core/has.js";
import { subclass as p } from "../../core/accessorSupport/decorators/subclass.js";
import { rendererSymbolProperty as a } from "./commonProperties.js";
import i from "./UniqueValue.js";
let n = class extends e(t) {
  constructor(r) {
    super(r), this.description = null, this.label = null, this.symbol = null, this.values = null;
  }
  castValues(r) {
    if (null == r) return null;
    const o = typeof (r = Array.isArray(r) ? r : [r])[0];
    return "string" === o || "number" === o ? r.map(r => new i({
      value: r
    })) : "object" === o ? r[0] instanceof i ? r : r.map(r => new i(r)) : null;
  }
};
r([s({
  type: String,
  json: {
    write: !0
  }
})], n.prototype, "description", void 0), r([s({
  type: String,
  json: {
    write: !0
  }
})], n.prototype, "label", void 0), r([s(a)], n.prototype, "symbol", void 0), r([s({
  type: [i],
  json: {
    type: [[String]],
    read: {
      reader: r => r ? r.map(r => new i({
        value: r[0],
        value2: r[1],
        value3: r[2]
      })) : null
    },
    write: {
      writer: (r, e) => {
        const t = [];
        for (const s of r) {
          const r = [s.value, s.value2, s.value3].filter(o).map(r => r.toString());
          t.push(r);
        }
        e.values = t;
      }
    }
  }
})], n.prototype, "values", void 0), r([l("values")], n.prototype, "castValues", null), n = r([p("esri.renderers.support.UniqueValueClass")], n);
const u = n;
export { u as default };